import React from "react";
import { Target, Compass } from "lucide-react";
import { PageHero, PageBody, STATIC_CONTENT, renderInstituteHtml } from "./_shared";
import { useCidco } from "./CidcoLayout";

export default function VisionMission() {
  const data = useCidco();
  const inst = data.institute || {};
  const vision = (inst.vision || "").trim() || STATIC_CONTENT.vision;
  const mission = (inst.mission || "").trim() || STATIC_CONTENT.mission;
  return (
    <div data-testid="cid-vision-mission">
      <PageHero eyebrow="Direction" title="Vision &amp; Mission" accent="cyan" />
      <PageBody>
        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-gradient-to-br from-[#0B2447] to-[#06183A] rounded-2xl p-8 text-white shadow-2xl relative overflow-hidden">
            <div className="absolute -top-10 -right-10 w-40 h-40 bg-[#06B6D4]/30 rounded-full blur-3xl" />
            <div className="relative">
              <div className="w-12 h-12 bg-[#06B6D4] rounded-xl flex items-center justify-center text-white mb-4 shadow-lg">
                <Target size={22} strokeWidth={2} />
              </div>
              <h2 className="font-['Poppins',sans-serif] font-bold text-3xl mb-3">Our Vision</h2>
              <div className="text-white/90 italic leading-relaxed font-['Poppins',sans-serif] text-lg prose prose-invert prose-sm max-w-none" data-testid="cid-vision-text" dangerouslySetInnerHTML={{ __html: renderInstituteHtml(vision) }} />
            </div>
          </div>
          <div className="bg-gradient-to-br from-[#FF6B1A] to-[#E55400] rounded-2xl p-8 text-white shadow-2xl relative overflow-hidden">
            <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-[#0B2447]/30 rounded-full blur-3xl" />
            <div className="relative">
              <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center text-[#E55400] mb-4 shadow-lg">
                <Compass size={22} strokeWidth={2} />
              </div>
              <h2 className="font-['Poppins',sans-serif] font-bold text-3xl mb-3">Our Mission</h2>
              <div className="text-white/95 italic leading-relaxed font-['Poppins',sans-serif] text-lg prose prose-invert prose-sm max-w-none" data-testid="cid-mission-text" dangerouslySetInnerHTML={{ __html: renderInstituteHtml(mission) }} />
            </div>
          </div>
        </div>
      </PageBody>
    </div>
  );
}
